import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, delay, count } from 'rxjs';
import ApiOptionsConfig from '../api-options.config';
import { JurisdictionsService } from './jurisdictions.service';
import { ItemProductsService } from './item-products.service';
import { ItemTypesService } from './item-types.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { StoreService } from '../../store.service';

const BASE_URL = '/items'
const params = new HttpParams().set('size', '9999');

@Injectable({
  providedIn: 'root'
})
export class ItemsService {

  
  accessToken: string = '';
  storeService: StoreService;
  httpClient: HttpClient;


  private jurisdictionsSubject = new BehaviorSubject<string[]>([]);
  public jurisdictions$ = this.jurisdictionsSubject.asObservable();
  private itemProductsSubject = new BehaviorSubject<string[]>([]);
  public itemProducts$ = this.itemProductsSubject.asObservable();
  private itemTypesSubject = new BehaviorSubject<string[]>([]);
  public itemTypes$ = this.itemTypesSubject.asObservable();

  constructor(private itemTypesService: ItemTypesService, private itemProductsService: ItemProductsService, private jurisdictionsService: JurisdictionsService) {
    
    this.jurisdictionsService.list({ params }).subscribe({
      next: (response: any) => {
        const updatedJurisdictions = response.data.jurisdictions;
        this.jurisdictionsSubject.next(updatedJurisdictions);
      },
      error: (error: any) => {
        console.error('Error fetching jurisdictions:', error);
      }
    });


    this.storeService = inject(StoreService);
    this.httpClient = inject(HttpClient);

    this.storeService.getAuthToken().subscribe(
      (data: any) => { this.accessToken = data ? data['accessToken'] : null }
    )
  }



  GET(url: string, params?: HttpParams): Observable<any> {
    let headers: { [key: string]: string } = {
      'Content-Type': 'application/json'
    }
    if (this.accessToken) {
      headers['Authorization'] = `Bearer ${this.accessToken}`;
    }

    return this.httpClient.get<any>(url, {
      headers,
      params
    });
  }

  POST(url: string, data: any, params?: HttpParams): Observable<any> {
    let headers: { [key: string]: string } = {
      'Content-Type': 'application/json'
    }
    if (this.accessToken) {
      headers['Authorization'] = `Bearer ${this.accessToken}`;
    }

    return this.httpClient.post<any>(url, data, {
      headers,
      params
    });
  }
  PUT(url: string, data: any, params?: HttpParams): Observable<any> {
    let headers: { [key: string]: string } = {
      'Content-Type': 'application/json'
    };

    if (this.accessToken) {
      headers['Authorization'] = `Bearer ${this.accessToken}`;
    }

    return this.httpClient.put<any>(url, data, {
      headers,
      params
    });
  }

  DELETE(url: string, params?: HttpParams): Observable<any> {
    let headers: { [key: string]: string } = {
      'Content-Type': 'application/json'
    }
    if (this.accessToken) {
      headers['Authorization'] = `Bearer ${this.accessToken}`;
    }

    return this.httpClient.delete<any>(url, {
      headers,
      params
    });
  }

  getUrl(path: string): string {
    return `${environment.apiBaseUrl}${path}`
  }







  list(options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(BASE_URL), options?.params);
  }

  detail(lawId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${lawId}`), options?.params);
  }

  create(data: any): Observable<any> {
    return this.POST(this.getUrl(BASE_URL), data);
  }

  update(lawId: number, data: any): Observable<any> {
    return this.PUT(this.getUrl(`${BASE_URL}/${lawId}`), data);
  }

  delete(lawId: number): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL}/${lawId}`));
  }


  listNotes(itemId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${itemId}/notes`), options?.params);
  }

  createNotes(itemId: number, data: any): Observable<any> {
    return this.POST(this.getUrl(`${BASE_URL}/${itemId}/notes`), data);
  }

  deleteNotes(itemId: number, sectionNoteId: number): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL}/${itemId}/notes/${sectionNoteId}`));
  }



  getItemProducts(): Observable<any> { 
    
    this.itemProductsService.list({ params }).subscribe({
      next: (response: any) => {
        const updatedItemProducts = response.data.itemProducts;
        this.itemProductsSubject.next(updatedItemProducts);
      },
      error: (error: any) => {
        console.error('Error fetching item products:', error);
      }
    });
    return this.itemProducts$;
  } 

  getItemTypes(): Observable<any> { 
    this.itemTypesService.list({ params }).subscribe({
      next: (response: any) => {
        const updatedItemTypes = response.data.itemTypes;
        this.itemTypesSubject.next(updatedItemTypes);
      },
      error: (error: any) => {
        console.error('Error fetching item types:', error);
      }
    });    
    return this.itemTypes$;
  }

     
    


}
